module.exports = __webpack_public_path__ + "img/hospitium-15.c1223382.jpg";